module.exports = __webpack_public_path__ + "img/1373058014.fb709238.jpg";